<template>
  <!-- 百科全书资源管理 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="dbWork"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dbWork" leftIndex="bkManage"></LeftSideBar>
    </div>
    <div id="sortContent">
      <div class="left-tree">
        <el-input
          class="subject-search-input"
          placeholder="请输入名称"
          v-model="treeSearchContent"
          style="margin-left: 20px"
        ></el-input>
        <el-tree
          ref="tree"
          v-if="opentree"
          :props="props"
          :load="loadNode"
          node-key="id"
          icon-class="el-icon-folder"
          :expand-on-click-node="false"
          :highlight-current="true"
          @node-click="listClick"
          :filter-node-method="treeSearch"
          lazy
        >
        </el-tree>
      </div>
      <div class="rightBox">
        <!-- 上方按钮 -->
        <div class="button-box">
          <!-- <el-button type="text" icon="el-icon-document-copy" size="small"
            >批量标引</el-button
          > -->
          <el-button
            type="text"
            icon="el-icon-delete"
            size="small"
            @click="preCheck('toDelete')"
            :disabled="this.listInnerCode == ''||isAll"
            >删除</el-button
          >
          <el-button
            type="text"
            icon="el-icon-refresh"
            size="small"
            @click="revertEntry()"
            :disabled="this.deleteIds.length == 0||isAll"
            >恢复</el-button
          >
          <el-button
            type="text"
            icon="el-icon-edit"
            size="small"
            @click="preCheck('toEdit')"
            :disabled="this.listInnerCode == ''||isAll"
            >编辑</el-button
          >
          <el-button
            type="text"
            icon="el-icon-bottom"
            size="small"
            @click="preCheck('toDown')"
            :disabled="this.listInnerCode == ''"
            >下架</el-button
          >
          <el-button
            type="text"
            icon="el-icon-top"
            size="small"
            @click="preCheck('toUP')"
            :disabled="this.listInnerCode == ''"
            >上架</el-button
          >
          <el-button
            type="text"
            icon="el-icon-c-scale-to-original"
            size="small"
            @click="createIndex()"
            :disabled="this.listInnerCode == ''||isAll"
            >创建索引</el-button
          >
          <el-button
            type="text"
            icon="el-icon-document-add"
            size="small"
            @click="wordInpoutDialog = true"
            :disabled="this.listInnerCode == ''||isAll"
            >word导入</el-button
          ><el-button
            type="text"
            icon="el-icon-refresh"
            size="small"
            @click="preCheck('save2redis')"
            :disabled="this.listInnerCode == ''||isAll"
            >更新缓存</el-button
          >
          <!-- <el-button
            type="text"
            icon="el-icon-refresh-right"
            size="small"
            @click="preCheck('incrUpdateItems')"
            :disabled="this.listInnerCode == ''"
            >增量更新</el-button
          > -->
          <el-button
            type="text"
            icon="el-icon-download"
            size="small"
            @click="SourceOut()"
            :disabled="this.listInnerCode == ''||isAll"
            >元数据导出</el-button
          >
          <el-button
            type="text"
            icon="el-icon-tickets"
            size="small"
            @click="listOut()"
            :disabled="this.listInnerCode == ''||isAll"
            >导出xml数据包</el-button
          >
          <el-button
            type="text"
            icon="el-icon-document-checked"
            size="small"
            @click="exportDataListByExcel()"
            :disabled="this.listInnerCode == ''||isAll"
            >根据Excel导出xml数据包</el-button
          >
          <el-button
            type="text"
            icon="el-icon-link"
            size="small"
            @click="setPublishUrlDialog = true"
            :disabled="this.listInnerCode == ''||isAll"
            >设置链接</el-button
          >
          <el-button
            type="text"
            icon="el-icon-plus"
            size="small"
            @click="toTagSet('Y')"
            :disabled="this.listInnerCode == ''"
            >添加广告标签</el-button
          >
          <el-button
            type="text"
            icon="el-icon-document-delete"
            size="small"
            @click="toTagSet('N')"
            :disabled="this.listInnerCode == ''"
            >删除广告标签</el-button
          >
          <el-button
            type="text"
            icon="el-icon-data-board"
            size="small"
            @click="markAdverStatusDialog = true;adverStatusFlag=''"
            :disabled="this.listInnerCode == ''"
            >是否可展示广告</el-button
          >
          <el-button
            type="text"
            icon="el-icon-collection-tag"
            size="small"
            @click="importWordTagDialog = true;importWordTagKey = 'tag';importWordTagFlag='';importWordTagFileList=[]"
            :disabled="this.listInnerCode == ''||isAll"
            >导入条目标签</el-button
          >
          <el-button
            type="text"
            icon="el-icon-postcard"
            size="small"
            @click="importWordTagDialog = true;importWordTagKey = 'level';importWordTagFlag='';importWordTagFileList=[]"
            :disabled="this.listInnerCode == ''||isAll"
            >导入安全级别</el-button
          >
          <!-- <el-button
            type="text"
            icon="el-icon-upload2"
            size="small"
            @click="reorderPre()"
            >导出列表</el-button
          > -->
          <!-- <el-button
            type="text"
            icon="el-icon-c-scale-to-original"
            size="small"
            @click="sourceCompare()"
            >资源对比</el-button
          > -->
        </div>
        <!-- 上方按钮end -->
        <div class="contentBox">
          <div id="searchBox">
            <el-form
              label-width="90px"
              ref="searchFileForm"
              :model="searchFileForm"
            >
              <el-form-item label="资源名称">
                <el-input
                  v-model="searchFileForm.name"
                  placeholder="请输入资源名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="来源">
                <el-select
                  placeholder="请选择来源"
                  v-model="searchFileForm.sourceId"
                  clearable
                >
                  <el-option
                    v-for="item in sourceList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="资源状态">
                <el-select v-model="searchFileForm.status" clearable>
                  <el-option value="10" label="下架"> </el-option>
                  <el-option value="20" label="上架"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="删除状态">
                <el-select v-model="searchFileForm.isRemove" clearable>
                  <el-option value="10" label="未删除"> </el-option>
                  <el-option value="20" label="已删除"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="安全级别">
                <el-select v-model="searchFileForm.securityLevel" clearable>
                  <el-option
                    v-for="item in securityLevelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否展示广告" label-width="100px">
                <el-select v-model="searchFileForm.isAdver" clearable>
                  <el-option value="10" label="否"> </el-option>
                  <el-option value="20" label="是"> </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="标引状态">
                <el-select placeholder="请选择来源">
                  <el-option> </el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item label="标引标签">
                <el-select placeholder="请选择来源">
                  <el-option> </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label-width="0px">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-search"
                  @click="
                    currentPage = 1;
                    onSearch();
                  "
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div>
            <div class="tip-text" v-if="this.listInnerCode == ''">
              请选择资源库
            </div>
            <!-- 主列表 -->
            <div v-if="this.listInnerCode != ''" class="bkManageBox">
              <!-- 全选弹窗 -->
              <div id="allBox" v-if="isAllBox">
                   <p style="margin-bottom:20px">
                    <span>是否全选操作?</span>
                  </p>
                  <p style="text-align: center;">
                    <el-button
                      type="primary"
                      style="margin-left: 10px;padding: 5px 10px;"
                      @click="isAllBox = false;isAll = true"
                      >是</el-button
                    >
                    <el-button style="padding: 5px 10px;" @click="isAllBox = false;isAll = false">否</el-button>
                  </p>
                </div>

              <el-table
                :data="bkTableData"
                v-loading="tableLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-customClass="loadingStyles"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
                @selection-change="handleTableSelectionChange"
                @select-all="handleSelectAll"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  min-width="80"
                  label="资源标题"
                  align="center"
                >
                 <template slot-scope="scope">
                    <p style="margin:0;display: flex;align-items: center;justify-content: center;">
                      <span v-html="scope.row.name"></span>
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="subjectInfo.name"
                  min-width="80"
                  label="分支"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="subjectInfo.anotherName"
                  min-width="80"
                  label="义项名"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="status"
                  show-overflow-tooltip
                  label="状态"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.status == 20"
                      >已上架</span
                    >
                    <span effect="dark" v-if="scope.row.status == 10"
                      >未上架</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isRemove"
                  show-overflow-tooltip
                  label="是否已被删除"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      effect="dark"
                      v-if="
                        scope.row.isRemove == 10 || scope.row.isRemove == null
                      "
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isRemove == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                 <el-table-column
                  prop="isAdver"
                  show-overflow-tooltip
                  label="是否展示广告"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.isAdver == 20"
                      >是</span
                    >
                    <span effect="dark" v-if="scope.row.isAdver == 10"
                      >否</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="sourceInfo.name"
                  show-overflow-tooltip
                  label="来源"
                  min-width="70px"
                  align="center"
                >
                </el-table-column
                ><el-table-column
                  prop="addUser"
                  show-overflow-tooltip
                  label="入库人"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  v-if="bkTableData.modifyTime"
                  prop="modifyTime"
                  show-overflow-tooltip
                  label="入库时间"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  v-if="!bkTableData.modifyTime"
                  prop="addTime"
                  show-overflow-tooltip
                  label="入库时间"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="securityLevel"
                  show-overflow-tooltip
                  label="安全级别"
                  align="center"
                  ><template slot-scope="scope">
                    <span v-if="scope.row.securityLevel == 10">低</span>
                    <span v-if="scope.row.securityLevel == 20">中</span
                    ><span v-if="scope.row.securityLevel == 30">高</span>
                    <span v-if="scope.row.securityLevel == 40">最高</span>
                  </template> </el-table-column
                >
                <el-table-column
                  prop="version"
                  show-overflow-tooltip
                  label="版本"
                  min-width="70px"
                  align="center"
                >
                </el-table-column
                >
                <el-table-column
                  show-overflow-tooltip
                  label="操作"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="versionView(scope.row)"
                      >【查看版本】</span
                    >
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="toEditFile(scope.row)"
                      >【源文件编辑】</span
                    >
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="preview(scope.row)"
                      >【预览】</span
                    >
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="publishPreview(scope.row)"
                      >【发布预览】</span
                    >
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="toViewTags(scope.row.id);tagViewDialog = true;"
                      >【查看标签】</span
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- 主列表分页 -->
              <div class="pagination-box">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalSize"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <!-- 删除确认弹窗 -->
          <el-dialog
            title="删除分类"
            :visible.sync="deletePreDialog"
            width="600px"
          >
            <div>确定删除该分类</div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="deleteEntry">确 定</el-button>
              <el-button @click="deletePreDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 删除条目广告标签确认弹窗 -->
          <el-dialog
            title="删除广告标签"
            :visible.sync="deleteItemTagsDialog"
            width="600px"
          >
            <div>确定给该条目删除此标签</div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="deleteItemTags">确 定</el-button>
              <el-button @click="deleteItemTagsDialog = false">取 消</el-button>
            </span>
          </el-dialog>

          <!-- 元数据导出弹窗 -->
          <el-dialog title="元数据导出" :visible.sync="outDialog" width="600px">
            <el-form>
              <el-form-item label="导出字段：">
                <el-select
                  v-model="exportForm.exportTitles"
                  clearable
                  multiple
                  collapse-tags
                  placeholder="请选择导出列表字段"
                >
                  <el-option
                    v-for="item in exportTitlesList"
                    :key="item.value"
                    :value="item.value"
                    :label="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="toExport()">确 定</el-button>
              <el-button @click="outDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 导出xml数据包弹窗 -->
          <el-dialog
            title="导出xml数据包"
            :visible.sync="listOutDialog"
            width="800px"
          >
            <el-form
              ref="exportDataListForm"
              :model="exportDataListForm"
              :rules="exportDataListRules"
              label-width="140px"
            >
              <el-form-item label="是否导出资源:" prop="isExportResource">
                <el-select v-model="exportDataListForm.isExportResource">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="exportDataListForm.isExportResource == '20'"
                label="是否导出水印:"
                prop="isExportWatermark"
              >
                <el-select v-model="exportDataListForm.isExportWatermark">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="是否导出原始资源:"
                prop="isExportSourceResource"
                v-if="exportDataListForm.isExportResource == '20'"
              >
                <el-select v-model="exportDataListForm.isExportSourceResource">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="导出用户:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expUser"
                  placeholder="请填写导出用户"
                ></el-input>
              </el-form-item>
              <el-form-item label="用途:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expYt"
                  placeholder="请填写用途"
                ></el-input>
              </el-form-item>
              <el-form-item label="使用人员:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.toUser"
                  placeholder="请填写使用人员"
                ></el-input>
              </el-form-item>
              <el-form-item label="使用部门:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.toDept"
                  placeholder="请填写使用部门"
                ></el-input>
              </el-form-item>
              <el-form-item label="审核意见:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expAudit"
                  placeholder="请填写审核意见"
                ></el-input>
              </el-form-item>
              <el-form-item label="导出时间:">
                <el-date-picker
                  v-model="exportDataListForm.expTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="exportDataList()"
                >确 定</el-button
              >
              <el-button @click="listOutDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 根据Excel导出xml数据包弹窗 -->
          <el-dialog
            title="根据Excel导出xml数据包"
            :visible.sync="exportDataListByExcelDialog"
            width="800px"
          >
            <el-form
              ref="exportDataListForm"
              :model="exportDataListForm"
              :rules="exportDataListRules"
              label-width="140px"
            >
              <el-form-item label="是否导出资源:" prop="isExportResource">
                <el-select v-model="exportDataListForm.isExportResource">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="exportDataListForm.isExportResource == '20'"
                label="是否导出水印:"
                prop="isExportWatermark"
              >
                <el-select v-model="exportDataListForm.isExportWatermark">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="是否导出原始资源:"
                prop="isExportSourceResource"
                v-if="exportDataListForm.isExportResource == '20'"
              >
                <el-select v-model="exportDataListForm.isExportSourceResource">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="导出用户:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expUser"
                  placeholder="请填写导出用户"
                ></el-input>
              </el-form-item>
              <el-form-item label="用途:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expYt"
                  placeholder="请填写用途"
                ></el-input>
              </el-form-item>
              <el-form-item label="使用人员:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.toUser"
                  placeholder="请填写使用人员"
                ></el-input>
              </el-form-item>
              <el-form-item label="使用部门:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.toDept"
                  placeholder="请填写使用部门"
                ></el-input>
              </el-form-item>
              <el-form-item label="审核意见:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expAudit"
                  placeholder="请填写审核意见"
                ></el-input>
              </el-form-item>
              <el-form-item label="导出时间:">
                <el-date-picker
                  v-model="exportDataListForm.expTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
            <el-upload
              ref="upload"
              action="zyk/a/exportDataListByExcel"
              :headers="headers"
              :file-list="fileList"
              name="upfile"
              :before-upload="excelBeforeUpload"
              :on-success="excelUploadSuccess"
              :on-error="excelUploaderror"
              :auto-upload="false"
              accept=".xlsx"
              :data="exportDataListForm"
              :limit="1"
            >
              <div slot="tip" class="el-upload__tip">
                文件格式：资源库条目ID，原始ID（两列写一列即可）
              </div>
              <el-button slot="trigger" size="small" type="primary"
                >选择文件</el-button
              >
              <!-- <el-button size="small" type="success" @click="submitUpload"
                >上传并导入</el-button
              > -->
            </el-upload>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="excelsubmitUpload"
                >确 定</el-button
              >
              <el-button @click="exportDataListByExcelDialog = false"
                >取 消</el-button
              >
            </span>
          </el-dialog>
          <!-- 资源对比弹窗 -->
          <el-dialog
            title="资源对比"
            :visible.sync="compareDialog"
            width="600px"
          >
            <el-upload>
              <el-button slot="trigger" size="small" type="primary"
                >选取文件</el-button
              >
              <el-button
                style="margin-left: 10px"
                size="small"
                type="success"
                hidden
                >上传到服务器</el-button
              >
            </el-upload>
            <el-button style="margin: 30px 0">对比模板下载</el-button>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button type="primary">开始对比</el-button>
              <el-button @click="compareDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 查看日志弹窗 -->
          <el-dialog
            title="资源对比"
            :visible.sync="logViewDialog"
            width="900px"
          >
            <p style="margin-bottom: 20px">
              查看词条日志：<span>菲律宾魔杖</span>
            </p>
            <el-table
              style="width: 100%"
              class="maintable"
              border
              :header-cell-style="{ background: '#f8f8f8' }"
            >
              <el-table-column type="index" min-width="50" align="center">
              </el-table-column>
              <el-table-column
                prop="name"
                show-overflow-tooltip
                min-width="80"
                label="名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="address"
                min-width="80"
                label="操作类型"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="操作明细"
                min-width="70px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="用户名"
                min-width="70px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="时间"
                align="center"
              >
              </el-table-column>
            </el-table>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button @click="logViewDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 查看版本弹窗 -->
          <el-dialog
            title="历史版本"
            :visible.sync="versionDialog"
            width="900px"
          >
            <el-table
              :data="versionListData"
              style="width: 100%"
              class="maintable"
              border
              :header-cell-style="{ background: '#f8f8f8' }"
            >
              <el-table-column type="index" min-width="50" align="center">
              </el-table-column>
              <el-table-column
                prop="wordName"
                show-overflow-tooltip
                min-width="80"
                label="条目名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="addUser"
                min-width="80"
                label="提交人"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="addTime"
                show-overflow-tooltip
                label="操作时间"
                min-width="70px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="version"
                show-overflow-tooltip
                label="版本号"
                width="80px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="操作"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    class="right-add-button"
                    style="display: block"
                    @click="preview2(scope.row)"
                    >【预览】</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="currentPage1"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize1"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize1"
              >
              </el-pagination>
            </div>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button @click="versionDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 编辑弹窗 -->
          <el-dialog
            title="编辑条目"
            :visible.sync="editDialog"
            width="1300px"
            class="editFile"
          >
            <el-form
              ref="editFileForm"
              :rules="editFileRules"
              :model="editFileForm"
            >
              <el-form-item label="条目名称：" label-width="90px">
                <el-input
                  v-model="editFileForm.name"
                  placeholder="请输入条目名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="义项名：" label-width="90px">
                <el-input
                  v-model="editFileForm.anotherName"
                  placeholder="请输入义项名"
                ></el-input>
              </el-form-item>
              <el-form-item label="首字母：" label-width="90px">
                <el-input
                  v-model="editFileForm.firstLetter"
                  placeholder="请输入首字母"
                ></el-input>
              </el-form-item>
              <el-form-item label="安全级别：" label-width="90px">
                <el-select
                  v-model="editFileForm.securityLevel"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="item in securityLevelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="条目简述："
                label-width="90px"
                class="editContent"
              >
                <el-input
                  type="textarea"
                  v-model="editFileForm.synopsis"
                  placeholder="请输入条目简述"
                ></el-input>
              </el-form-item>
              <el-form-item label="条头：" label-width="90px" class="addInput">
                <div
                  v-for="item in headTextTable"
                  :key="item.name"
                  class="addInputBox"
                >
                  <el-input
                    v-model="item.name"
                    placeholder="请输入条头名称"
                  ></el-input>
                  <el-input
                    v-model="item.value"
                    placeholder="请输入条头内容"
                  ></el-input>
                  <el-button type="primary" @click="deleteHTInput(item)"
                    >删除</el-button
                  >
                </div>
                <el-button type="primary" @click="addHTInput(headTextTable)"
                  >添加</el-button
                >
              </el-form-item>
              <el-form-item label="摘要：" label-width="90px" class="addInput">
                <div
                  v-for="item in summaryFieldsTable"
                  :key="item.name"
                  class="addInputBox"
                >
                  <el-input
                    v-model="item.name"
                    placeholder="请输入摘要名称"
                  ></el-input>
                  <el-input
                    v-model="item.value"
                    placeholder="请输入摘要内容"
                  ></el-input>
                  <el-button type="primary" @click="deleteSFInput(item)"
                    >删除</el-button
                  >
                </div>
                <el-button
                  type="primary"
                  @click="addHTInput(summaryFieldsTable)"
                  >添加</el-button
                >
              </el-form-item>
              <el-form-item label="作者：" label-width="90px" class="addInput">
                <div
                  v-for="item in authorTextTable"
                  :key="item.authorName"
                  class="addInputBox"
                  style="width: 50%; float: left"
                >
                  <el-input
                    v-model="item.authorName"
                    placeholder="请输入作者名称"
                  ></el-input>
                  <el-button type="primary" @click="deleteATInput(item)"
                    >删除</el-button
                  >
                </div>
                <el-button type="primary" @click="addHTInput(authorTextTable)"
                  >添加</el-button
                >
              </el-form-item>
              <el-form-item
                label="定性语："
                label-width="90px"
                class="editContent"
              >
                <el-input
                  type="textarea"
                  v-model="editFileForm.descText"
                  placeholder="请输入定性语"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="著作："
                label-width="90px"
                class="addInput addTable"
              >
                <el-table
                  :data="opusTextTable"
                  border
                  style="width: 100%"
                  v-if="opusTextTable.length != 0"
                >
                  <el-table-column type="index" min-width="50" align="center">
                  </el-table-column>
                  <el-table-column
                    prop="publishauthor"
                    label="出版社"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="publishYear"
                    label="出版年份"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column prop="mainPerson" label="主要负责人">
                  </el-table-column>
                  <el-table-column prop="publishAddress" label="出版地">
                  </el-table-column>
                  <el-table-column prop="bookName" label="题名">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <span @click="deleteTable('opus', scope.row)">删除</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button type="primary" @click="addopus">添加</el-button>
              </el-form-item>
              <el-form-item
                label="引文："
                label-width="90px"
                class="addInput addTable"
              >
                <!-- 添加引文div -->
                <div class="addref">
                  <el-select
                    placeholder="请选择来源"
                    v-model="refCurrent"
                    style="margin-right: 20px"
                    clearable
                  >
                    <el-option value="1" label="著作"> </el-option>
                    <el-option value="2" label="期刊"> </el-option>
                  </el-select>
                  <el-button type="primary" @click="addRefInput(refCurrent)"
                    >添加</el-button
                  >
                </div>
                <!-- refTextTable -->
                <!-- 引文-著作展示 -->
                <el-table
                  :data="ref1Table"
                  border
                  style="width: 100%; margin-bottom: 20px"
                  v-if="ref1Table.length != 0"
                >
                  <el-table-column label="著作" width="150">
                    <el-table-column
                      prop="publishauthor"
                      label="出版社"
                      width="180"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="publishYear"
                      label="出版年份"
                      width="180"
                    >
                    </el-table-column>
                    <el-table-column prop="mainPerson" label="主要负责人">
                    </el-table-column>
                    <el-table-column prop="publishAddress" label="出版地">
                    </el-table-column>
                    <el-table-column prop="bookName" label="题名">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <span @click="deleteTable('ref1', scope.row)"
                          >删除</span
                        >
                      </template>
                    </el-table-column></el-table-column
                  >
                </el-table>
                <!-- 引文-期刊展示 -->
                <el-table
                  :data="ref2Table"
                  border
                  style="width: 100%; margin-bottom: 20px"
                  v-if="ref2Table.length != 0"
                >
                  <el-table-column label="期刊" width="150">
                    <el-table-column
                      prop="mainPerson"
                      label="主要责任人"
                      width="100"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="bookName"
                      label="析出文献题名"
                      width="180"
                    >
                    </el-table-column>
                    <el-table-column prop="bookNameL" label="连续出版物提名">
                    </el-table-column>
                    <el-table-column prop="bookNameQ" label="其他提名信息">
                    </el-table-column>
                    <el-table-column prop="publishYear" label="出版年">
                    </el-table-column>
                    <el-table-column prop="Volume" label="卷（期）">
                    </el-table-column>
                    <el-table-column prop="pageNumber" label="页码">
                    </el-table-column>
                    <el-table-column prop="linkAddress" label="链接地址">
                    </el-table-column
                    ><el-table-column label="操作">
                      <template slot-scope="scope">
                        <span @click="deleteTable('ref2', scope.row)"
                          >删除</span
                        >
                      </template>
                    </el-table-column></el-table-column
                  >
                </el-table>
              </el-form-item>
              <el-form-item
                label="扩展阅读："
                label-width="90px"
                class="addInput addTable"
              >
                <!-- 添加扩展阅读div -->
                <div class="addref">
                  <el-select
                    placeholder="请选择来源"
                    v-model="expendCurrent"
                    style="margin-right: 20px"
                    clearable
                  >
                    <el-option value="1" label="讲话"> </el-option>
                    <el-option value="2" label="著作"> </el-option>
                    <el-option value="3" label="期刊"> </el-option>
                    <el-option value="4" label="慕课"> </el-option>
                    <el-option value="5" label="机构场馆"> </el-option>
                  </el-select>
                  <el-button
                    type="primary"
                    @click="addExtendInput(expendCurrent)"
                    >添加</el-button
                  >
                </div>
                <!-- 扩展阅读展示列表 -->
                <!-- 扩展阅读-讲话展示 -->
                <el-table
                  :data="extend1Table"
                  border
                  style="width: 100%; margin-bottom: 20px"
                  v-if="extend1Table.length != 0"
                >
                  <el-table-column label="讲话" width="150">
                    <el-table-column prop="leaders" label="领导人">
                    </el-table-column>
                    <el-table-column prop="speechName" label="讲话名称">
                    </el-table-column>
                    <el-table-column prop="linkAddress" label="链接地址">
                    </el-table-column
                    ><el-table-column label="操作">
                      <template slot-scope="scope">
                        <span @click="deleteTable('extend1', scope.row)"
                          >删除</span
                        >
                      </template>
                    </el-table-column></el-table-column
                  >
                </el-table>
                <!-- 扩展阅读-著作展示 -->
                <el-table
                  :data="extend2Table"
                  border
                  style="width: 100%; margin-bottom: 20px"
                  v-if="extend2Table.length != 0"
                >
                  <el-table-column label="著作" width="150">
                    <el-table-column
                      prop="publishauthor"
                      label="出版社"
                      width="180"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="publishYear"
                      label="出版年份"
                      width="180"
                    >
                    </el-table-column>
                    <el-table-column prop="mainPerson" label="主要负责人">
                    </el-table-column>
                    <el-table-column prop="publishAddress" label="出版地">
                    </el-table-column>
                    <el-table-column prop="bookName" label="题名">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <span @click="deleteTable('extend2', scope.row)"
                          >删除</span
                        >
                      </template>
                    </el-table-column></el-table-column
                  >
                </el-table>
                <!-- 扩展阅读-期刊展示 -->
                <el-table
                  :data="extend3Table"
                  border
                  style="width: 100%; margin-bottom: 20px"
                  v-if="extend3Table.length != 0"
                >
                  <el-table-column label="期刊" width="150">
                    <el-table-column
                      prop="mainPerson"
                      label="主要责任人"
                      width="100"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="bookName"
                      label="析出文献题名"
                      width="180"
                    >
                    </el-table-column>
                    <el-table-column prop="bookNameL" label="连续出版物提名">
                    </el-table-column>
                    <el-table-column prop="bookNameQ" label="其他提名信息">
                    </el-table-column>
                    <el-table-column prop="publishYear" label="出版年">
                    </el-table-column>
                    <el-table-column prop="Volume" label="卷（期）">
                    </el-table-column>
                    <el-table-column prop="pageNumber" label="页码">
                    </el-table-column>
                    <el-table-column prop="linkAddress" label="链接地址">
                    </el-table-column
                    ><el-table-column label="操作">
                      <template slot-scope="scope">
                        <span @click="deleteTable('extend3', scope.row)"
                          >删除</span
                        >
                      </template>
                    </el-table-column></el-table-column
                  >
                </el-table>
                <!-- 扩展阅读-慕课展示 -->
                <el-table
                  :data="extend4Table"
                  border
                  style="width: 100%; margin-bottom: 20px"
                  v-if="extend4Table.length != 0"
                >
                  <el-table-column label="慕课课程" width="150">
                    <el-table-column
                      prop="bookName"
                      label="课程名称"
                      width="100"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="websiteName"
                      label="网站名称"
                      width="180"
                    >
                    </el-table-column>
                    <el-table-column prop="linkAddress" label="链接地址">
                    </el-table-column
                    ><el-table-column label="操作">
                      <template slot-scope="scope">
                        <span @click="deleteTable('extend4', scope.row)"
                          >删除</span
                        >
                      </template>
                    </el-table-column></el-table-column
                  >
                </el-table>
                <!-- 扩展阅读-机构场馆展示 -->
                <el-table
                  :data="extend5Table"
                  border
                  style="width: 100%; margin-bottom: 20px"
                  v-if="extend5Table.length != 0"
                >
                  <el-table-column label="机构场馆" width="150">
                    <el-table-column
                      prop="name"
                      label="机构场馆名称"
                      width="300"
                    >
                    </el-table-column>
                    <el-table-column prop="linkAddress" label="链接地址">
                    </el-table-column
                    ><el-table-column label="操作">
                      <template slot-scope="scope">
                        <span @click="deleteTable('extend5', scope.row)"
                          >删除</span
                        >
                      </template>
                    </el-table-column></el-table-column
                  >
                </el-table>
              </el-form-item>
              <el-form-item
                label="年表："
                label-width="90px"
                class="addInput addTable"
              >
                <el-table
                  :data="chronologyTable"
                  border
                  style="width: 100%; margin-bottom: 20px"
                >
                  <!-- v-if="chronologyTable.length != 0" -->
                  <el-table-column type="index" min-width="50" align="center">
                  </el-table-column>
                  <el-table-column
                    prop="sbeginTime"
                    label="开始日期"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column prop="sendTime" label="结束日期" width="180">
                  </el-table-column>
                  <el-table-column prop="sorder" label="顺序">
                  </el-table-column>
                  <el-table-column prop="sText" label="描述"> </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <span @click="deleteTable('chronology', scope.row)"
                        >删除</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <el-button type="primary" @click="addChronology"
                  >添加</el-button
                >
              </el-form-item>
            </el-form>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button type="primary" @click="bkEdit(editFileForm)"
                >确 定
              </el-button>
              <el-button @click="editDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 添加著作弹窗 -->
          <el-dialog
            :title="opusDialogTitle"
            :visible.sync="addopusDialog"
            width="600px"
          >
            <el-form ref="addopusForm" :model="addopusForm">
              <el-form-item
                label="出版社："
                label-width="100px"
                class="addInput"
              >
                <el-input
                  v-model="addopusForm.publishauthor"
                  placeholder="请输入出版社"
                ></el-input
              ></el-form-item>
              <el-form-item
                label="出版年份："
                label-width="100px"
                class="addInput"
              >
                <el-input
                  v-model="addopusForm.publishYear"
                  placeholder="请输入出版年份"
                ></el-input></el-form-item
              ><el-form-item
                label="主要负责人："
                label-width="100px"
                class="addInput"
              >
                <el-input
                  v-model="addopusForm.mainPerson"
                  placeholder="请输入主要负责人"
                ></el-input></el-form-item
              ><el-form-item
                label="出版地："
                label-width="100px"
                class="addInput"
              >
                <el-input
                  v-model="addopusForm.publishAddress"
                  placeholder="请输入出版地"
                ></el-input></el-form-item
              ><el-form-item
                label="题名："
                label-width="100px"
                class="addInput"
              >
                <el-input
                  v-model="addopusForm.bookName"
                  placeholder="请输入题名"
                ></el-input></el-form-item
            ></el-form>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button type="primary" @click="checkAddopus('addopusForm')"
                >确 定
              </el-button>
              <el-button @click="addopusDialog = false">取 消</el-button>
            </span></el-dialog
          >
          <!-- 添加期刊弹窗 -->
          <el-dialog
            :title="journalDialogTitle"
            :visible.sync="addJournalDialog"
            width="600px"
          >
            <el-form
              ref="addJournalForm"
              :model="addJournalForm"
              style="padding: 10px"
            >
              <el-form-item
                label="主要责任人："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addJournalForm.mainPerson"
                  placeholder="请输入主要责任人"
                ></el-input
              ></el-form-item>
              <el-form-item
                label="析出文献题名："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addJournalForm.bookName"
                  placeholder="请输入析出文献题名"
                ></el-input></el-form-item
              ><el-form-item
                label="连续出版物提名："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addJournalForm.bookNameL"
                  placeholder="请输入连续出版物提名"
                ></el-input></el-form-item
              ><el-form-item
                label="其他提名信息："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addJournalForm.bookNameQ"
                  placeholder="请输入其他提名信息"
                ></el-input></el-form-item
              ><el-form-item
                label="出版年："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addJournalForm.publishYear"
                  placeholder="请输入出版年"
                ></el-input></el-form-item
              ><el-form-item
                label="卷（期）："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addJournalForm.Volume"
                  placeholder="请输入卷（期）"
                ></el-input></el-form-item
              ><el-form-item
                label="页码："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addJournalForm.pageNumber"
                  placeholder="请输入页码"
                ></el-input></el-form-item
              ><el-form-item
                label="链接地址："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addJournalForm.linkAddress"
                  placeholder="请输入链接地址"
                ></el-input></el-form-item
            ></el-form>

            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button
                type="primary"
                @click="checkAddJournal('addJournalForm')"
                >确 定
              </el-button>
              <el-button @click="addJournalDialog = false">取 消</el-button>
            </span></el-dialog
          >
          <!-- 添加讲话弹窗 -->
          <el-dialog
            title="添加扩展阅读讲话"
            :visible.sync="addSpeechDialog"
            width="600px"
          >
            <el-form
              ref="addSpeechForm"
              :model="addSpeechForm"
              style="padding: 10px"
            >
              <el-form-item
                label="领导人："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addSpeechForm.leaders"
                  placeholder="请输入领导人"
                ></el-input
              ></el-form-item>
              <el-form-item
                label="讲话名称："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addSpeechForm.speechName"
                  placeholder="请输入讲话名称"
                ></el-input></el-form-item
              ><el-form-item
                label="链接地址："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addSpeechForm.linkAddress"
                  placeholder="请输入链接地址"
                ></el-input></el-form-item
            ></el-form>

            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button type="primary" @click="checkAddSpeech('addSpeechForm')"
                >确 定
              </el-button>
              <el-button @click="addSpeechDialog = false">取 消</el-button>
            </span></el-dialog
          >
          <!-- 添加慕课弹窗 -->
          <el-dialog
            title="添加扩展阅读慕课课程"
            :visible.sync="addMoocDialog"
            width="600px"
          >
            <el-form
              ref="addMoocForm"
              :model="addMoocForm"
              style="padding: 10px"
            >
              <el-form-item
                label="课程名称："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addMoocForm.bookName"
                  placeholder="请输入课程名称"
                ></el-input
              ></el-form-item>
              <el-form-item
                label="网站名称："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addMoocForm.websiteName"
                  placeholder="请输入讲网站名称"
                ></el-input></el-form-item
              ><el-form-item
                label="链接地址："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addMoocForm.linkAddress"
                  placeholder="请输入链接地址"
                ></el-input></el-form-item
            ></el-form>

            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button type="primary" @click="checkAddMooc('addMoocForm')"
                >确 定
              </el-button>
              <el-button @click="addMoocDialog = false">取 消</el-button>
            </span></el-dialog
          >
          <!-- 添加机构场馆弹窗 -->
          <el-dialog
            title="添加扩展阅读机构场馆"
            :visible.sync="addAgencyDialog"
            width="600px"
          >
            <el-form
              ref="addAgencyForm"
              :model="addAgencyForm"
              style="padding: 10px"
            >
              <el-form-item
                label="机构场馆名称："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addAgencyForm.name"
                  placeholder="请输入机构场馆名称"
                ></el-input
              ></el-form-item>
              <el-form-item
                label="链接地址："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addAgencyForm.linkAddress"
                  placeholder="请输入链接地址"
                ></el-input></el-form-item
            ></el-form>

            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button type="primary" @click="checkAddAgency('addAgencyForm')"
                >确 定
              </el-button>
              <el-button @click="addAgencyDialog = false">取 消</el-button>
            </span></el-dialog
          >
          <!-- 添加年表弹窗 -->
          <el-dialog
            title="添加年表"
            :visible.sync="addChronologyDialog"
            width="600px"
          >
            <el-form
              ref="addChronologyForm"
              :model="addChronologyForm"
              style="padding: 10px"
            >
              <el-form-item
                label="开始日期："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addChronologyForm.sbeginTime"
                  placeholder="请输入开始日期"
                ></el-input
              ></el-form-item>
              <el-form-item
                label="结束日期："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addChronologyForm.sendTime"
                  placeholder="请输入结束日期"
                ></el-input
              ></el-form-item>
              <el-form-item
                label="排序："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  v-model="addChronologyForm.sorder"
                  placeholder="请输入排序"
                ></el-input
              ></el-form-item>
              <el-form-item
                label="描述："
                label-width="130px"
                class="addInput"
                style="width: 95%"
              >
                <el-input
                  type="textarea"
                  v-model="addChronologyForm.sText"
                  placeholder="请输入描述"
                ></el-input></el-form-item
            ></el-form>

            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button
                type="primary"
                @click="checkAddChronology('addChronologyForm')"
                >确 定
              </el-button>
              <el-button @click="addChronologyDialog = false">取 消</el-button>
            </span></el-dialog
          >
          <!-- word导入弹窗 -->
          <el-dialog
            title="word导入"
            :visible.sync="wordInpoutDialog"
            width="600px"
            @open="noClick = false"
          >
            <div class="uploadBox">
              <el-upload
                ref="upload"
                action="zyk/word/importByDocx"
                :headers="headers"
                :file-list="fileList"
                name="upfile"
                :before-upload="beforeUpload"
                :on-success="uploadSuccess"
                :on-error="uploaderror"
                :auto-upload="false"
                accept=".zip"
                :data="upLodeData"
                :limit="1"
              >
                <div slot="tip" class="el-upload__tip">
                  必须为zip压缩文件,且资源超过上传上限4G，如仍需上传，请联系管理员。
                </div>
                <el-button slot="trigger" size="small" type="primary"
                  >选择文件</el-button
                >
                <el-button size="small" type="success" @click="submitUpload"
                  >上传并导入</el-button
                >
                <el-button
                  size="small"
                  style="margin-left: '15px'"
                  @click="templateDownload"
                  >导入模板下载</el-button
                >
              </el-upload>
            </div>
          </el-dialog>
          
          <!-- 导入条目标签、安全级别弹窗 -->
          <el-dialog
            title="导入条目标签、安全级别"
            :visible.sync="importWordTagDialog"
            width="600px"
            @open="noClick = false"
          >
            <div style="margin-bottom: 20px;">
              <el-radio v-model="importWordTagFlag" label="10">增量</el-radio>
              <el-radio v-model="importWordTagFlag" label="20">覆盖</el-radio>
            </div>
            <div class="uploadBox">
              <el-upload
                ref="importWordTagUpload"
                action="zyk/word/importWordTag"
                :headers="headers"
                :file-list="importWordTagFileList"
                name="upfile"
                :before-upload="importWordTagBeforeUpload"
                :on-success="importWordTagUploadSuccess"
                :on-error="importWordTagUploaderror"
                :auto-upload="false"
                accept=".xls, .xlsx"
                :data="importWordTagUpLodeData"
                :limit="1"
              >
                <div slot="tip" class="el-upload__tip">
                  必须为excel压缩文件,且资源超过上传上限4G，如仍需上传，请联系管理员。
                </div>
                <el-button slot="trigger" size="small" type="primary"
                  >选择文件</el-button
                >
                <el-button size="small" type="success" @click="importWordTagSubmitUpload"
                  >上传并导入</el-button
                >
              </el-upload>
            </div>
          </el-dialog>

          <!-- 下增量更新模板弹窗 -->
          <!-- <el-dialog
            title="增量更新"
            :visible.sync="incrUpdateDialog"
            width="600px"
          >
            <el-select v-model="incrUpdateType" clearable>
              <el-option value="c" label="添加"></el-option>
              <el-option value="d" label="删除"></el-option>
              <el-option value="u" label="修改"></el-option>
            </el-select>
            <el-button
              type="primary"
              style="margin-left: 10px"
              @click="incrUpdate"
              >更新</el-button
            >
            <a class="downloadText"></a>
            <span slot="footer" class="dialog-footer">
              <el-button @click="incrUpdateDialog = false">关 闭</el-button>
            </span>
          </el-dialog> -->

          <!-- 修改发布预览链接弹窗 -->
          <el-dialog
            title="修改发布预览链接"
            :visible.sync="setPublishUrlDialog"
            width="600px"
          >
            <div>
              <span>链接地址：</span>
              <el-input
                style="width: 80%"
                v-model="pubishPath"
                placeholder="请输入发布预览链接"
              ></el-input>
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="setPublishUrl()"
                >确 定</el-button
              >
              <el-button @click="setPublishUrlDialog = false">关 闭</el-button>
            </span>
          </el-dialog>

          <!-- 添加、删除标签管理弹窗 -->
          <el-dialog
            :title="tagSetTitle"
            :visible.sync="tagSetDialog"
            width="600px"
          >
          <div id="tagSearchBox">
            <el-form
              label-width="80px"
              ref="tagSearchFileForm"
              :model="tagSearchFileForm"
              class="clearfix"

              style="padding: 10px 0;"
            >
              <el-form-item label="广告名称">
                <el-input
                  v-model="tagSearchFileForm.name"
                  placeholder="请输入广告名称"
                  style="width:200px"
                ></el-input>
              </el-form-item>              
              <el-form-item label-width="0px">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-search"
                  @click="
                    onTagSearch();
                  "
                  style="margin-left:10px;"

                  >查询</el-button
                >
              </el-form-item>
            </el-form>
          </div>
            <el-checkbox-group v-model="checkAdverTag">
              <el-checkbox-button v-for="item in adverTagList" :label="item.id" :key="item.id" >{{item.name}}</el-checkbox-button>
            </el-checkbox-group>
            
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="setAdverTag()">确 定</el-button>
              <el-button @click="tagSetDialog = false">关 闭</el-button>
            </span>
          </el-dialog>  


          <!-- 是否可展示广告弹窗 -->
          <el-dialog
            title="是否可展示广告"
            :visible.sync="markAdverStatusDialog"
            width="600px"
          >
            <el-radio v-model="adverStatusFlag" label="10">不可展示</el-radio>
            <el-radio v-model="adverStatusFlag" label="20">可展示</el-radio>
            
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="toMarkAdverStatus()">确 定</el-button>
              <el-button @click="markAdverStatusDialog = false">关 闭</el-button>
            </span>
          </el-dialog>  

          
          <!-- 导出过程提示弹窗 -->
          <el-dialog title="导出" 
            :visible.sync="outProcessDialog" 
            :close-on-click-modal="false" 
            width="600px">
            <p>数据导出中，请稍后……</p>
          </el-dialog>
          
          <!-- 查看标签弹窗 -->
          <el-dialog
            title="查看广告标签"
            :visible.sync="tagViewDialog"
            width="600px"
          >
            <!-- 上方按钮 -->
            <div class="button-box">
              <el-button
                type="text"
                icon="el-icon-plus"
                size="small"
                @click="toItemTagSet('Y')"
                :disabled="this.listInnerCode == ''"
                >添加广告标签</el-button
              >
              <el-button
                type="text"
                icon="el-icon-close"
                size="small"
                @click="toItemTagSet('N')"
                :disabled="this.listInnerCode == ''"
                >删除广告标签</el-button
              >
            </div>
            <!-- 上方按钮end -->
            <el-checkbox-group v-model="checkItemAdverTag">
              <el-checkbox-button v-for="item in currentAdverTagList" :label="item.tagId" :key="item.tagId" >{{item.name}}</el-checkbox-button>
            </el-checkbox-group>
            
            <span slot="footer" class="dialog-footer">
                  <el-button @click="tagViewDialog = false">关 闭</el-button>
                </span>
          </el-dialog> 

           <!-- 过程提示弹窗 -->
          <el-dialog
            :title="processTitle"
            :visible.sync="processDialog"
            width="600px"
            :show-close="false"
          >
            <p>{{processTitle}}中，请勿进行任何操作……</p>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data: function () {
    return {
      exportTitlesList: [],
      fileList: [], //上传文件列表
      importWordTagFileList:[],
      entryId: "",
      pubishPath: "",
      incrUpdateType: "",
      incrUpdateId: "",
      processTitle:"",
      itemId:"",
      headers: {
        AuthorizationToken: cookies.get("token"),
      },
      upLodeData: {
        subjectId: "",
      },
      importWordTagUpLodeData:{},
      sourceOuting: false,
      listData: [],
      tableLoading: false,
      isAll:false,
      isAllBox:false,
      getAuthority: {},
      versionListData: [],
      adverTagList: [],
      currentAdverTagList:[],
      deleteIds: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 50,
      currentPage1: 1,
      pageSize1: 10,
      totalSize1: 50,
      dataText: "",
      optionData: [],
      bkTableData: [],
      treeData: [],
      treeNode_had: [],
      treeResolve_had: [],
      multipleSelectionTable: [],
      sourceList: [],
      headTextTable: {
        name: "",
        value: "",
      },
      summaryFieldsTable: {
        name: "",
        value: "",
      },
      authorTextTable: {
        authorName: "",
      },
      tagCurrent:"",
      adverStatusFlag:"",
      importWordTagFlag:"",
      importWordTagKey:"",
      // 弹窗标题
      opusDialogTitle: "著作",
      journalDialogTitle: "",
      // 著作
      opusTextTable: [],
      // 引文
      ref1Table: [],
      ref2Table: [],
      refCurrent: "",
      expendCurrent: "",
      addopusForm: {},
      addJournalForm: {},

      // 扩展阅读
      extend1Table: [],
      extend2Table: [],
      extend3Table: [],
      extend4Table: [],
      extend5Table: [],
      addSpeechForm: {},
      addMoocForm: {},
      addAgencyForm: {},

      // 年表
      chronologyTable: [],
      addChronologyForm: {},

      searchFileForm: {},
      securityLevelList: [
        { label: "低", value: 10 },
        { label: "中", value: 20 },
        { label: "高", value: 30 },
        { label: "最高", value: 40 },
      ],
      treeSearchContent: "",
      listInnerCode: "",
      listTreeId:"",
      opentree: true,
      fileName: "",
      checkAdverTag:[],
      checkItemAdverTag:[],
      tagSetTitle:"",
      // 所有from
      sortContentForm: {},
      exportForm: {},
      editFileForm: {},
      exportDataListForm: {},
      excleUpLodeData: {},
      modifyItemAdverTagFrom:{},
      modifyAdverTagFrom:{},
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },
      tagSearchFileForm:{},
      // 弹窗组
      outDialog: false,
      deletePreDialog: false,
      listOutDialog: false,
      exportDataListByExcelDialog: false,
      compareDialog: false,
      logViewDialog: false,
      versionDialog: false,
      editDialog: false,
      addopusDialog: false,
      addJournalDialog: false,
      addSpeechDialog: false,
      addMoocDialog: false,
      addAgencyDialog: false,
      addChronologyDialog: false,
      wordInpoutDialog: false,
      incrUpdateDialog: false,
      setPublishUrlDialog: false,
      tagSetDialog:false,
      tagViewDialog:false,
      deleteItemTagsDialog:false,
      markAdverStatusDialog:false,
      importWordTagDialog:false,      
      processDialog:false,      
      outProcessDialog:false,
      // 规则
      editFileRules: {},
      exportDataListRules: {
        isExportWatermark: [
          { required: true, message: "请选择请选择", trigger: "blur" },
        ],
        isExportResource: [
          { required: true, message: "请选择是否导出资源", trigger: "blur" },
        ],
        isExportSourceResource: [
          {
            required: true,
            message: "请选择是否导出原始资源",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    // this.searchParam();
    this.getSourceList();
  },
  watch: {
    treeSearchContent(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    // 搜索
    onSearch() {
      this.searchParam();
    },
    onTagSearch() {
      this.getAdverTagList();
    },
    // 加载数据
    searchParam() {
      let that = this;
      let params = Object.assign({}, this.searchFileForm);
      params.innerCode = this.listInnerCode;
      params.type = 10;
      params.size = this.pageSize;
      params.page = this.currentPage;
      that.tableLoading = true;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/subject/wordInfo/list",
        data: params,
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj.list && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.tableLoading = false;
            that.totalSize = response.obj.total;
            that.bkTableData = response.obj.list;
            that.currentPage = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 树形结构加载
    loadNode(node, resolve) {
      let that = this;
      this.getAuthority = node;
      var currentToken = cookies.get("token");
      $.ajax({
        url: "/zyk/c/subject/subjectInfo/list?size=1000&page=1",
        type: "GET",
        data: { type: 10 },
        headers: {
          AuthorizationToken: currentToken,
        },
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (node.level == 0) {
            this.treeNode_had = node;
            that.dataList = data.obj.list;
            return resolve(that.dataList);
          } else {
            $.ajax({
              url: "/zyk/c/subject/subjectInfo/list?size=1000&page=1",
              type: "GET",
              //contentType: 'application/json;charset=utf-8',
              data: { id: node.data.id },
              dataType: "json",
              error: function (xhr) {
                if (xhr.status == 401) {
                  window.location.reload();
                }
              },
              success: function (data) {
                return resolve(data.obj.list);
              },
            });
          }
        },
      });
    },
    // 点击树
    listClick(node) {
      let that = this;
      that.getAuthority = node;
      if (node.id == -1) {
        that.sortContentForm = {
          id: "-1",
          name: "百科数据资源库",
        };
      } else {
        that.listInnerCode = node.innerCode;
        that.listTreeId = node.id;
        that.currentPage = 1;
        that.searchFileForm = {};
        that.searchParam();
      }
    },
    // 编辑、上下架前确认
    preCheck(current) {
      let that = this;
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      let flagArr = [];
      let flag = true;
      let statusArr = this.multipleSelectionTable.map((item) => {
        return item.status;
      });
      if (this.multipleSelectionTable.length == 0) {
        if (current == "save2redis") {
          console.log("重新添加全库的内容");
          // $.ajax({
          //   type: "GET",
          //   dataType: "json",
          //   url: "/zyk/word/save2redis",
          //   // contentType: "text/xml",
          //   success: function (response) {
          //     that.$message({
          //       message: response.msg,
          //       duration: 0,
          //       showClose: true,
          //       type: "success",
          //       offset: 100,
          //     });
          //   },
          //   error: function (data) {
          //     console.log(data);
          //   },
          // });
        } else {
          this.$message({
            message: "请选中具体的资源",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "toDown") {
        if(this.isAll){
          let params = {};
          params.subjectId = this.listTreeId;
          params.toStatus = 10;
          this.processDialog = true;
          this.processTitle="取消发布"
          $.ajax({
              type: "POST",
              dataType: "json",
              data: params,
              url: "/zyk/word/updown",
              success: function (response) {
                if (response.code == 200) {
                  that.searchParam();
                  that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "success",
                    offset: 100,
                  });
                } else {
                  that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                  });
                }
                // that.processDialog = false;
                that.isAll = false
              },
              error: function (data) {
                console.log(data);
              },
            })
        }else{
        $.each(statusArr, function (index, element) {
          if (element === 20) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "资源下架状态，不可重复下架",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          $.ajax({
            type: "POST",
            dataType: "json",
            data: {
              ids: ids.toString(),
              toStatus: 10,
            },
            url: "/zyk/word/updown",
            success: function (response) {
              if (response.code == 200) {
                that.searchParam();
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              console.log(data);
            },
          });
        }
      }
      } else if (current == "toUP") {
        if(this.isAll){
          let params = {};
          params.subjectId = this.listTreeId;
          params.toStatus = 20,
          this.processDialog = true;
          this.processTitle="发布"
          $.ajax({
              type: "POST",
              dataType: "json",
              data: params,
              url: "/zyk/word/updown",
              success: function (response) {
                if (response.code == 200) {
                  that.searchParam();
                  that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "success",
                    offset: 100,
                  });
                } else {
                  that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                  });
                }
                that.processDialog = false;
                that.isAll = false
              },
              error: function (data) {
                console.log(data);
              },
            })
        }else{
        $.each(statusArr, function (index, element) {
          if (element === 10) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "资源上架状态，不可重复上架",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          $.ajax({
            type: "POST",
            dataType: "json",
            data: {
              ids: ids.toString(),
              toStatus: 20,
            },
            url: "/zyk/word/updown",
            success: function (response) {
              if (response.code == 200) {
                that.searchParam();
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              console.log(data);
            },
          });
        }
      }
      } else if (current == "toEdit") {
        if (this.multipleSelectionTable.length == 1) {
          that.refCurrent = "";
          that.expendCurrent = "";
          this.editFile(this.multipleSelectionTable[0]);
        } else {
          this.$message({
            message: "请勿选择多个资源进行编辑",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "toDelete") {
        $.each(statusArr, function (index, element) {
          if (element === 10) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "资源上架状态，请下架后再删除",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          this.deletePreDialog = true;
        }
      } else if (current == "save2redis") {
        if (this.multipleSelectionTable.length == 1) {
          $.ajax({
            type: "GET",
            dataType: "json",
            url: "/zyk/word/save2redis",
            data: { id: this.multipleSelectionTable[0].id },
            success: function () {
              that.$message({
                message: "更新缓存成功",
                duration: 0,
                showClose: true,
                type: "success",
                offset: 100,
              });
            },
            error: function (data) {
              console.log(data);
            },
          });
        } else {
          this.$message({
            message: "请勿选择多个资源更新",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "incrUpdateItems") {
        if (this.multipleSelectionTable.length == 1) {
          that.incrUpdateDialog = true;
          that.incrUpdateId = this.multipleSelectionTable[0].id;
        } else {
          this.$message({
            message: "请勿选择多个资源更新",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      }
    },
    // 编辑资源
    editFile(row) {
      let that = this;
      that.editFileForm = {};
      $.ajax({
        url: "/zyk/word/preview",
        type: "GET",
        dataType: "json",
        data: { id: row.id },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            var dataArry = data.obj;
            if (dataArry.headText != "") {
              that.headTextTable = JSON.parse(dataArry.headText);
            } else {
              that.headTextTable = [];
            }
            if (dataArry.summaryFields != "") {
              that.summaryFieldsTable = JSON.parse(dataArry.summaryFields);
            } else {
              that.summaryFieldsTable = [];
            }
            if (dataArry.authorText != "") {
              that.authorTextTable = JSON.parse(dataArry.authorText);
            } else {
              that.authorTextTable = [];
            }
            if (dataArry.opusText != "") {
              that.opusTextTable = JSON.parse(dataArry.opusText);
            } else {
              that.opusTextTable = [];
            }
            if (dataArry.chronologyText && dataArry.chronologyText != "{}") {
              that.chronologyTable = JSON.parse(dataArry.chronologyText).list;
            } else {
              that.chronologyTable = [];
            }

            // 获取引文列表内容
            var refList = JSON.parse(dataArry.refText);
            for (var i = 0; i < refList.length; i++) {
              if (refList[i].type == 1) {
                that.ref1Table = refList[i].list;
              } else if (refList[i].type == 2) {
                that.ref2Table = refList[i].list;
              }
            }
            if (dataArry.extendText != []) {
              var extendList = JSON.parse(dataArry.extendText);
              for (var j = 0; j < extendList.length; j++) {
                if (extendList[j].type == 1) {
                  that.extend1Table = extendList[j].list;
                } else if (extendList[j].type == 2) {
                  that.extend2Table = extendList[j].list;
                } else if (extendList[j].type == 3) {
                  that.extend3Table = extendList[j].list;
                } else if (extendList[j].type == 4) {
                  that.extend4Table = extendList[j].list;
                } else if (extendList[j].type == 5) {
                  that.extend5Table = extendList[j].list;
                }
              }
            }

            that.editFileForm = {
              id: row.id,
              version: dataArry.version,
              isuar: 10,
              isure: 10,
              name: dataArry.name,
              anotherName: row.anotherName,
              itemImg: "",
              firstLetter: row.firstLetter,
              synopsis: row.synopsis,
              securityLevel: row.securityLevel,
              descText: dataArry.descText,
            };
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
      this.editDialog = true;
    },
    // 编辑确认
    bkEdit(formName) {
      let that = this;
      // 转换条头
      that.editFileForm.headText = JSON.stringify(that.headTextTable);
      // 转换摘要
      that.editFileForm.summaryFields = JSON.stringify(that.summaryFieldsTable);
      // 转换作者
      that.editFileForm.authorText = JSON.stringify(that.authorTextTable);
      // 转换著作
      that.editFileForm.opusText = JSON.stringify(that.opusTextTable);
      // 转换年表
      that.editFileForm.chronologyText = JSON.stringify(that.chronologyTable);
      
      // 转换引文
      var refTextAll = [
        { type: "1", list: that.ref1Table },
        { type: "2", list: that.ref2Table },
      ].filter((obj) => obj.list.length != 0);
      that.editFileForm.refText = JSON.stringify(refTextAll);

      // 转换扩展阅读
      var extendText = [
        { type: "1", list: that.extend1Table },
        { type: "2", list: that.extend2Table },
        { type: "3", list: that.extend3Table },
        { type: "4", list: that.extend4Table },
        { type: "5", list: that.extend5Table },
      ].filter((obj) => obj.list.length != 0);

      that.editFileForm.extendText = JSON.stringify(extendText);
      console.log(formName);
      $.ajax({
        url: "/zyk/c/subject/wordInfo/update",
        type: "POST",
        dataType: "json",
        data: that.editFileForm,
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "修改成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.searchParam();
            that.editDialog = false;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    sourceCompare() {
      this.compareDialog = true;
    },
    logView() {
      this.logViewDialog = true;
    },
    versionView(row) {
      this.versionDialog = true;
      let that = this;
      let params = {};
      console.log(row);
      
      this.entryId = row.id;
      params.wordId = row.id;
      params.size = this.pageSize;
      params.page = this.currentPage;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/subject/wordExtendInfo/list",
        data: params,
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.length == 0) {
              that.dataText = "暂无数据";
            }
            console.log(that.optionData);
            that.totalSize1 = response.obj.total;
            that.versionListData = response.obj.list;
            that.fileName = that.optionData.wordName;
            that.currentPage1 = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 上传文件之前的钩子，对文件大小进行校验
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 / 1024 < 4;
      if (!isLt2M) {
        this.$message.error("资源超过上传上限4G，如仍需上传，请联系管理员。");
        return isLt2M;
      } else {
        this.upLodeData = {
          subjectId: this.getAuthority.id,
        };
      }
    },
    // 上传成功的钩子
    uploadSuccess(response) {
      let that = this;
      that.searchParam();
      that.$message({
        message: response.msg,
        duration: 0,
        showClose: true,
        type: "success",
        offset: 100,
      });
      // this.successDialog = true;
      // this.successTitle = "资源包上传结果";
      // this.successContent = "上传成功！";
      that.wordInpoutDialog = false;
    },
    uploaderror(err) {
      console.log(err);
    },
    // 文件上传
    submitUpload() {
      this.$refs.upload.data.subjectId = this.getAuthority.id;
      // this.$refs.upload.data.runtimeKey = $.now();
      // this.$refs.upload.data.sourceId = this.sourceContent;
      this.$refs.upload.submit();
    },
    // 上传文件之前的钩子，对文件大小进行校验
    importWordTagBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 / 1024 < 4;
      if (!isLt2M) {
        this.$message.error("资源超过上传上限4G，如仍需上传，请联系管理员。");
        return isLt2M;
      }
      //  else {
      //   this.upLodeData = {
      //     subjectId: this.getAuthority.id,
      //   };
      // }
    },
    // 上传成功的钩子
    importWordTagUploadSuccess(response) {
      let that = this;
      that.searchParam();
      that.$message({
        message: response.msg,
        duration: 0,
        showClose: true,
        type: "success",
        offset: 100,
      });
      // this.successDialog = true;
      // this.successTitle = "资源包上传结果";
      // this.successContent = "上传成功！";
      that.importWordTagDialog = false;
    },
    importWordTagUploaderror(err) {
      console.log(err);
    },
    // 文件上传
    importWordTagSubmitUpload() {
      this.$refs.importWordTagUpload.data.key = this.importWordTagKey;
      this.$refs.importWordTagUpload.data.flag = this.importWordTagFlag;
      this.$refs.importWordTagUpload.submit();
    },
    // 下载导入模板
    templateDownload() {
      let that = this;
      var downloadA = document.createElement("a");
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/zyk/word/downloadDocxTemplate",
        success: function (response) {
          if (response.code == 200) {
            downloadA.href = response.obj.url;
            downloadA.download;
            downloadA.click();
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
      this.isAll = false;
    },
    // 左侧树搜索
    treeSearch(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
    // 分页
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.versionView();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.versionView();
    },
    addHTInput(currentTable) {
      var tableLength = currentTable.length + 1;
      if (currentTable == this.authorTextTable) {
        currentTable.push({ id: tableLength, authorName: "" });
      } else {
        currentTable.push({ id: tableLength, name: "", value: "" });
      }
    },
    // 条头删除
    deleteHTInput(row) {
      let that = this;
      that.headTextTable = $.grep(that.headTextTable, function (table) {
        return table.name != row.name;
      });
    },
    // 摘要删除
    deleteSFInput(row) {
      let that = this;
      that.summaryFieldsTable = $.grep(
        that.summaryFieldsTable,
        function (table) {
          return table.name != row.name;
        }
      );
    },
    // 作者删除
    deleteATInput(row) {
      let that = this;
      that.authorTextTable = $.grep(that.authorTextTable, function (table) {
        return table.authorText != row.authorText;
      });
    },
    // 预览页面跳转
    preview(row) {
      var downloadA = document.createElement("a");
      downloadA.href = "/preview?id=" + row.id;

      downloadA.target = "_blank";
      downloadA.click();
    },
    publishPreview(row) {
      var currentPath = row.subjectInfo.path;
      var downloadA = document.createElement("a");
      if (currentPath) {
        downloadA.href = "/" + currentPath + "?id=" + row.id;
      } else {
        downloadA.href = "/detail?id=" + row.id;
      }
      downloadA.target = "_blank";
      downloadA.click();
    },
    // 查看版本预览页面跳转
    preview2(row) {
      var downloadA = document.createElement("a");
      downloadA.href =
        "/preview?id=" + this.entryId + "&version=" + row.version;
      downloadA.target = "_blank";
      downloadA.click();
    },
    // 获取来源list
    getSourceList() {
      let that = this;
      $.ajax({
        type: "GET",
        dataType: "json",
        data: {
          page: 1,
          size: 1000,
        },
        url: "/zyk/c/source/sourceInfo/list",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.sourceList = response.obj.list;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    toEditFile(row) {
      localStorage.setItem("wordId", row.id);
      window.open("/contentEdit", "_blank");
    },
    // 添加著作
    addopus() {
      let that = this;
      this.addopusDialog = true;
      that.addopusForm = {};
    },
    // 添加著作
    checkAddopus() {
      let that = this;
      if (this.opusDialogTitle == "添加引文著作") {
        that.ref1Table.push(this.addopusForm);
      } else if (this.opusDialogTitle == "添加扩展阅读著作") {
        that.extend2Table.push(this.addopusForm);
      } else {
        that.opusTextTable.push(this.addopusForm);
      }
      that.addopusDialog = false;
    },
    // 添加引文
    addRefInput(refCurrent) {
      let that = this;
      if (refCurrent == 1) {
        that.opusDialogTitle = "添加引文著作";
        that.addopusForm = {};
        this.addopusDialog = true;
      } else if (refCurrent == 2) {
        that.journalDialogTitle = "添加引文期刊";
        that.addJournalForm = {};
        this.addJournalDialog = true;
      }
    },
    // 添加扩展阅读
    addExtendInput(expendCurrent) {
      let that = this;
      if (expendCurrent == 1) {
        that.addSpeechForm = {};
        this.addSpeechDialog = true;
      } else if (expendCurrent == 2) {
        that.opusDialogTitle = "添加扩展阅读著作";
        that.addopusForm = {};
        this.addopusDialog = true;
      } else if (expendCurrent == 3) {
        that.journalDialogTitle = "添加扩展阅读期刊";
        that.addJournalForm = {};
        this.addJournalDialog = true;
      } else if (expendCurrent == 4) {
        that.addMoocForm = {};
        this.addMoocDialog = true;
      } else if (expendCurrent == 5) {
        that.addAgencyForm = {};
        this.addAgencyDialog = true;
      }
    },
    // 添加期刊
    checkAddJournal() {
      let that = this;
      if (this.journalDialogTitle == "添加引文期刊") {
        that.ref2Table.push(this.addJournalForm);
      } else if (this.journalDialogTitle == "添加扩展阅读期刊") {
        that.extend3Table.push(this.addJournalForm);
      }
      that.addJournalDialog = false;
    },
    // 添加讲话
    checkAddSpeech() {
      let that = this;
      that.extend1Table.push(this.addSpeechForm);
      that.addSpeechDialog = false;
    },
    // 添加慕课课程
    checkAddMooc() {
      let that = this;
      that.extend4Table.push(this.addMoocForm);
      that.addMoocDialog = false;
    },
    // 添加机构场馆
    checkAddAgency() {
      let that = this;
      that.extend5Table.push(this.addAgencyForm);
      that.addAgencyDialog = false;
    },
    // 删除表格
    deleteTable(current, row) {
      let that = this;
      if (current == "opus") {
        that.opusTextTable = this.opusTextTable.filter((item) => item != row);
      } else if (current == "ref1") {
        that.ref1Table = this.ref1Table.filter((item) => item != row);
      } else if (current == "ref2") {
        that.ref2Table = this.ref2Table.filter((item) => item != row);
      } else if (current == "extend1") {
        that.extend1Table = this.extend1Table.filter((item) => item != row);
      } else if (current == "extend2") {
        that.extend2Table = this.extend2Table.filter((item) => item != row);
      } else if (current == "extend3") {
        that.extend3Table = this.extend3Table.filter((item) => item != row);
      } else if (current == "extend4") {
        that.extend4Table = this.extend4Table.filter((item) => item != row);
      } else if (current == "extend5") {
        that.extend5Table = this.extend5Table.filter((item) => item != row);
      } else if (current == "chronology") {
        that.extend5Table = this.chronologyTable.filter((item) => item != row);
      }
    },
    // 添加年表
    addChronology() {
      this.addChronologyDialog = true;
    },
    // 年表确认
    checkAddChronology() {
      let that = this;
      that.chronologyTable.push(this.addChronologyForm);
      this.addChronologyDialog = false;
    },
    // 删除条目
    deleteEntry() {
      let that = this;
      that.deleteIds = this.multipleSelectionTable.map((item) => {
        return item.id;
      });

      $.ajax({
        url: "/zyk/c/subject/wordInfo/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: this.deleteIds.toString() },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.deletePreDialog = false;
            that.searchParam();
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 恢复条目
    revertEntry() {
      let that = this;
      $.ajax({
        url: "/zyk/c/subject/wordInfo/revert",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: this.deleteIds.toString() },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "恢复成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.searchParam();
            that.deleteIds = [];
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 创建索引
    createIndex() {
      let params = Object.assign({}, this.searchFileForm);
      params.type = 10;
      let that = this;
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      if (ids.length == 0) {
        params.innerCode = this.listInnerCode;
      } else {
        params.ids = ids.toString();
      }
      $.ajax({
        type: "POST",
        dataType: "json",
        data: params,
        url: "/zyk/word/createIndex",
        success: function (response) {
          if (response.code == 200) {
            that.$message({
              message: "索引已创建",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 增量更新
    // incrUpdate() {
    //   var that = this;
    //   if (this.incrUpdateType == "") {
    //     that.$message({
    //       message: "请选择操作",
    //       duration: 0,
    //       showClose: true,
    //       type: "error",
    //       offset: 100,
    //     });
    //   } else {
    //     console.log(this.incrUpdateType, this.incrUpdateId);
    //     $.ajax({
    //       type: "POST",
    //       dataType: "json",
    //       url: "/zyk/word/incrUpdateItems",
    //       data: { wordId: this.incrUpdateId, falg: this.incrUpdateType },
    //       success: function () {
    //         that.$message({
    //           message: "增量更新成功",
    //           duration: 0,
    //           showClose: true,
    //           type: "success",
    //           offset: 100,
    //         });
    //       },
    //       error: function (data) {
    //         console.log(data);
    //       },
    //     });
    //   }
    // },
    // 元数据导出
    SourceOut() {
      var that = this;
      that.exportTitlesList = [];
      that.exportForm = Object.assign({}, this.searchFileForm);
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      that.exportForm.ids = ids.toString();
      that.exportForm.exportKey = "Word";
      that.exportForm.innerCode = this.listInnerCode;
      this.outDialog = true;
      $.ajax({
        url: "/zyk/a/exportList",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        data: that.exportForm,
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          var tagData = data.obj;
          for (var i = 0; i < tagData.length; i++) {
            that.exportTitlesList.push({
              value: tagData[i],
            });
          }
        },
      });
    },
    // 列表导出确认
    toExport() {
      var that = this;
      that.exportForm.exportTitles = this.exportForm.exportTitles.toString();
      var downloadA = document.createElement("a");
      this.outDialog = false;
      this.outProcessDialog = true;
      $.ajax({
        url: "/zyk/a/exportList",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        data: this.exportForm,
        dataType: "json",
        error: function (xhr) {
          console.log(xhr);
        },
        success: function (data) {
          if (data.code == 200) {
            downloadA.href = data.obj;
            downloadA.download;
            downloadA.click();
            that.outProcessDialog = false;
          }else{
            that.outProcessDialog = false;
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 导出xml数据包
    listOut() {
      var that = this;
      that.exportDataListForm = Object.assign({}, this.searchFileForm);
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      that.exportDataListForm.ids = ids.toString();
      that.exportDataListForm.exportKey = "Word";
      that.exportDataListForm.innerCode = this.listInnerCode;
      this.listOutDialog = true;
    },
    // 导出xml数据包确认
    exportDataList() {
      var that = this;
      console.log(this.exportDataListForm);
      if (this.exportDataListForm.isExportResource == "10") {
        this.exportDataListForm.isExportWatermark = "10";
        this.exportDataListForm.isExportSourceResource = "10";
      }
      $.ajax({
        url: "/zyk/a/exportDataList",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        data: this.exportDataListForm,
        dataType: "json",
        error: function (xhr) {
          that.$message({
            message: xhr.msg,
            duration: 2000,
            showClose: true,
            type: "error",
            offset: 100,
          });
          that.listOutDialog = false;
        },
        success: function (data) {
          that.$message({
            message: data.msg,
            duration: 2000,
            showClose: true,
            type: "success",
            offset: 100,
          });
          that.listOutDialog = false;
        },
      });
    },
    // 根据Excel导出xml数据包提交
    exportDataListByExcel() {
      this.exportDataListByExcelDialog = true;
      var that = this;
      that.exportDataListForm.exportKey = "Word";
    },
    // 上传文件之前的钩子，对文件大小进行校验
    excelBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 / 1024 < 4;

      if (!isLt2M) {
        this.$message.error("资源超过上传上限4G，如仍需上传，请联系管理员。");
        return isLt2M;
      } else {
        console.log("excleUpLodeData:" + this.excleUpLodeData);
      }
    },
    // 上传成功的钩子
    excelUploadSuccess(response) {
      let that = this;
      that.searchParam();
      that.$message({
        message: response.msg,
        duration: 0,
        showClose: true,
        type: "success",
        offset: 100,
      });
      that.exportDataListByExcelDialog = false;
    },
    excelUploaderror(err) {
      console.log(err);
    },
    excelsubmitUpload() {
      if (this.exportDataListForm.isExportResource == "10") {
        this.exportDataListForm.isExportWatermark = "10";
        this.exportDataListForm.isExportSourceResource = "10";
      }
      this.$refs.upload.submit();
    },
    // 设置发布链接
    setPublishUrl() {
      var that = this;
      $.ajax({
        url: "/zyk/subject/updatePath",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        data: { innerCode: this.listInnerCode, path: this.pubishPath },
        dataType: "json",
        error: function (xhr) {
          that.$message({
            message: xhr.msg,
            duration: 2000,
            showClose: true,
            type: "error",
            offset: 100,
          });
          that.searchParam();
          that.setPublishUrlDialog = false;
        },
        success: function (data) {
          that.$message({
            message: data.msg,
            duration: 2000,
            showClose: true,
            type: "success",
            offset: 100,
          });
          that.setPublishUrlDialog = false;
        },
      });
    },
    toItemTagSet(flag){
      this.modifyItemAdverTagFrom={
        flag:flag
      }
      switch (flag) {
        case "Y":
          this.tagSetTitle = "添加广告标签"
          this.checkAdverTag = [];
          this.getAdverTagList();
          this.tagSetDialog = true;
          this.tagCurrent = "itemAdd"
          break;
        case "N":
          this.tagSetTitle = "删除广告标签"
          if(this.checkItemAdverTag.length == 0){
            this.$message({
              message: "请选择要删除的标签",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }else{
            this.deleteItemTagsDialog = true
          }
          break;
        default:
          break;
      }
    },
    deleteItemTags(){
      var that = this;
      this.modifyItemAdverTagFrom.tagIds = this.checkItemAdverTag.toString();
      this.modifyItemAdverTagFrom.wordIds = this.itemId;
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/zyk/adver/modifyItemAdverTag",
        data: this.modifyItemAdverTagFrom,
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "success",
                offset: 100,
              });
              that.toViewTags(that.itemId);
              that.deleteItemTagsDialog = false;
          } else {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
              });
          }
        },
        error: function (data) {
          console.log(data);
        },
      }); 
    },
    // 获取广告标签列表
    getAdverTagList(){
        var that = this;
        let params = Object.assign({}, this.tagSearchFileForm);
        params.size = 1000;
        params.page = 1;
        $.ajax({
            type: "GET",
            dataType: "json",
            url: "/zyk/c/adver/adverTag/list",
            data:params,
            success: function (response) {
              if (response.code == 200) {
                that.adverTagList = response.obj.list;
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              console.log(data);
            },
          });
    },
    setAdverTag(){
      var that = this;
      switch (this.tagCurrent) {
        // 列表添加、删除广告标签
        case "list":
          this.tagSearchFileForm = {}
          if(this.multipleSelectionTable.length <= 0 || this.isAll){
            this.modifyItemAdverTagFrom.tagIds = this.checkAdverTag.toString();
            this.modifyItemAdverTagFrom.wordIds = "";
            this.modifyItemAdverTagFrom.subjectId = this.getAuthority.id;
          }else{
            this.modifyItemAdverTagFrom.tagIds = this.checkAdverTag.toString();
            this.modifyItemAdverTagFrom.wordIds = this.multipleSelectionTable.map((item) => {
              return item.id;
            }).toString();
            this.modifyItemAdverTagFrom.subjectId = "";
          }
          break;
        // 条目添加广告标签
        case "itemAdd":
          this.tagSearchFileForm = {}
          this.modifyItemAdverTagFrom.tagIds = this.checkAdverTag.toString();
          this.modifyItemAdverTagFrom.wordIds = this.itemId;
          this.modifyItemAdverTagFrom.subjectId = "";
          break;
        default:
          break;
      }
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/zyk/adver/modifyItemAdverTag",
        data: this.modifyItemAdverTagFrom,
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "success",
                offset: 100,
              });
              switch (this.tagCurrent) {
                case "list":
                  that.searchParam();
                  break;
                case "itemAdd":
                  that.toViewTags(that.itemId);
                  break;
                default:
                  break;
              }
              that.tagSetDialog = false;
          } else {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
              });
          }
        },
        error: function (data) {
          console.log(data);
        },
      }); 
    },
    toViewTags(itemId){
      var that = this;
      this.itemId = itemId;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/adver/listItemTag",
        data: {wordId:itemId},
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
        if (response.code == 200) {
            that.currentAdverTagList = response.obj;
        } else {
            that.$message({
            message: response.msg,
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
            });
        }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 添加删除广告标签
    toTagSet(flag){
      this.modifyItemAdverTagFrom={
        flag:flag
      }
      this.tagCurrent = "list"
      switch (flag) {
        case "Y":
          this.tagSetTitle = "添加广告标签"
          // this.tagCurrent = "listAdd"
          break;
        case "N":
          this.tagSetTitle = "删除广告标签"
          
          // this.tagCurrent = "listDelete"
          break;
        default:
          break;
      }
      this.checkAdverTag = [];
      this.getAdverTagList();
      this.tagSetDialog = true;
    },
    // 是否可展示广告确认
    toMarkAdverStatus(){
      var that = this;
      var param = {};
      param.flag = this.adverStatusFlag;
      if(this.multipleSelectionTable.length <= 0 || this.isAll){
        param.wordIds = "";
        param.subjectId = this.getAuthority.id;
      }else{
        param.wordIds = this.multipleSelectionTable.map((item) => {
          return item.id;
        }).toString();
        param.subjectId = "";
      }
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/zyk/word/markAdverStatus",
        data: param,
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "success",
                offset: 100,
              }); 
              that.searchParam();
              that.markAdverStatusDialog = false;
          } else {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
              });
          }
        },
        error: function (data) {
          console.log(data);
        },
      }); 
    },
    handleSelectAll(selection) {
      if(selection.length == this.pageSize ){
        this.isAllBox = true
      }else{
        this.isAll = false
      }
    },
  },
};
</script>

<style>
#sortContent {
  clear: both;
  margin-top: -8px;
  margin-left: 170px;
}

.rightBox {
  float: right;
  width: calc(100% - 250px);
}
.information {
  width: 100%;
}

.el-dialog .el-form {
  padding: 10px 50px;
}

.reorderPreDialog {
  text-align: center;
}

.reorderPreDialog .el-input {
  display: inline;
}
.reorderPreDialog input {
  width: 100px;
}
.reorderPreDialog .red {
  color: red;
}

.editFile .el-dialog {
  margin-top: 0 !important;
}

.editFile .editContent {
  width: 98% !important;
}

.editFile .el-form {
  padding: 0 !important;
  height: 500px;
}

.editFile .el-form-item.addInput {
  box-shadow: 0 0 2px #888;
  width: 98% !important;
  padding: 10px 10px;
}

.editFile .addInput label {
  display: block;
  float: none !important;
  width: 100% !important;
  padding-left: 20px;
  text-align: left;
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}

.editFile .el-form-item {
  float: left;
  width: 50% !important;
}

.mainBox {
  overflow: auto;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
}
.mainBox::after,
.mainBox .leftBoxDialog {
  content: "";
  display: inline-block;
  clear: both;
}
.mainBox .leftBoxDialog {
  width: 30%;
  float: left;
  border-right: 1px solid #dcdfe6;
}
.mainBox .leftBoxDialog input {
  width: 100%;
  height: 30px;
  font-size: 14px;
}
.mainBox .leftBoxDialog .el-input,
.mainBox .leftBoxDialog .el-select {
  float: left;
}
.mainBox .leftBoxDialog .leftUp {
  border-bottom: 1px solid #50b58d;
  padding: 10px 0 10px 10px;
}

.mainBox .leftBoxDialog .el-input__icon {
  line-height: 30px;
}
.mainBox .rightBoxDialog {
  width: 69%;
  float: left;
}

.mainBox .rightBoxDialog .dialogBtnBox {
  border-bottom: 1px solid #50b58d;
  padding: 8px 0 8px 10px;
}

.mainBox .rightBoxDialog .el-form {
  padding: 10px 20px;
}

.mainBox .rightBoxDialog .el-form .el-textarea textarea {
  height: 300px;
}

#searchBox {
  padding-bottom: 22px;
}

#searchBox .el-select {
  width: 202px;
}

#searchBox .el-form-item {
  margin-bottom: 0;
}

#searchBox .el-form button.el-button {
  margin-left: 20px !important;
}

#searchBox .el-date-editor .el-range__icon {
  line-height: 25px;
}

#searchBox.el-date-editor .el-range-separator {
  line-height: 23px;
}

.addInputBox .el-input {
  width: 200px;
  margin-right: 20px;
  margin-bottom: 20px;
}

.addTable .el-form-item__content {
  margin-left: 0 !important;
}

.addref {
  margin-bottom: 20px;
}

.bkManageBox {
  position: relative;
  font-family: "DBKai";
}

.bkManageBox .tableLoading {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  line-height: 200px;
  text-align: center;
  z-index: 10;
}

.left-tree .el-tree > .el-tree-node {
  display: inline-block;
  min-width: 100%;
}

#tagSearchBox .el-form-item{
  float: left;
  width: auto;
}
</style>